export const NODE_ENV: string = (process.env.NODE_ENV || 'svil').toUpperCase();

export const ICONS: Record<string, string> = {
  ADD_CIRCLE: 'mdi-plus-circle-outline',
  ADD_USER: 'mdi-account-plus-outline',
  ACCOUNT: 'mdi-account',
  ACCOUNT_CIRCLE: 'mdi-account-circle',
  ACCOUNT_CLOCK_OUTLINE: 'mdi-account-clock-outline',
  ACCOUNT_OFF_OUTLINE: 'mdi-account-off-outline',
  ACCOUNT_EYE: 'mdi-account-eye',
  ACCOUNT_EYE_OUTLINE: 'mdi-account-eye-outline',
  ACCOUNT_GROUP: 'mdi-account-group',
  ALERT: 'mdi-alert',
  ALERT_DECAGRAM: 'mdi-alert-decagram',
  BAR_CHART: 'mdi-chart-box-outline',
  BELL_RING: 'mdi-bell-ring',
  CALENDAR_CHECK: 'mdi-calendar-check',
  CALENDAR_MINUS: 'mdi-calendar-minus',
  CALENDAR_PLUS: 'mdi-calendar-plus',
  CHECK: 'mdi-check-circle',
  CIRCLE: 'mdi-circle',
  CLIPBOARD_ACCOUNT: 'mdi-clipboard-account-outline',
  CLIPBOARD_CHECK: 'mdi-clipboard-check-outline',
  CLIPBOARD_REMOVE: 'mdi-clipboard-remove-outline',
  CLOCK: 'mdi-clock-outline',
  CLUSTER: 'mdi-view-grid-outline',
  CLOSE: 'mdi-close',
  DELETE: 'mdi-delete-outline',
  EDIT: 'mdi-pencil-outline',
  EDIT_USER: 'mdi-account-edit-outline',
  EMAIL: 'mdi-email-outline',
  FLOW_CHART: 'mdi-sitemap-outline',
  HOME: 'mdi-home',
  HAMBURGER_MENU: 'mdi-view-list',
  INBOX: 'mdi-inbox-full',
  INBOX_SEND: 'mdi-inbox-arrow-up',
  INFO: 'mdi-information',
  INFO_OUTLINE: 'mdi-information-outline',
  LENS: 'mdi-magnify',
  LOGOUT: 'mdi-logout',
  MAP: 'mdi-map',
  MAP_LEGEND: 'mdi-map-legend',
  MAP_MARKER_RADIUS: 'mdi-map-marker-radius',
  MICROPHONE: 'mdi-microphone',
  MICROPHONE_OFF: 'mdi-microphone-off',
  NOTIFICATIONS: 'mdi-bell-outline',
  OFFICE_CONFIG: 'mdi-office-building-cog-outline',
  ORDER_DESCENDING: 'mdi-order-bool-descending',
  PAUSE: 'mdi-pause',
  PHONE: 'mdi-phone',
  PHONE_CLOCK: 'mdi-phone-clock',
  PHONE_OFF: 'mdi-phone-off',
  PHONE_OUTLINE: 'mdi-phone-outline',
  PHONE_HANGUP: 'mdi-phone-hangup',
  PLAY: 'mdi-play',
  RADIO_BUTTON: 'mdi-radiobox-blank',
  RADIO_BUTTON_CHECK: 'mdi-check-circle-outline',
  RADIO_BUTTON_CLOSE: 'mdi-close-circle-outline',
  RECORDING: 'mdi-record',
  RECORDING_OFF: 'mdi-stop-circle',
  REFRESH: 'mdi-refresh',
  RHOMBUS_MEDIUM: 'mdi-rhombus-medium',
  RHOMBUS_MEDIUM_OUTLINE: 'mdi-rhombus-medium-outline',
  RHOMBUS_SPLIT: 'mdi-rhombus-split',
  SCREEN_SHARE: 'mdi-monitor',
  SCREEN_SHARE_OFF: 'mdi-monitor-off',
  SERVER_NETWORK: 'mdi-server-network',
  TABLE: 'mdi-table',
  TABLE_STAR: 'mdi-table-star',
  TIMELINE: 'mdi-timeline-outline',
  TEAMS: 'mdi-microsoft-teams',
  VOLUME_HIGH: 'mdi-volume-high',
  VOLUME_OFF: 'mdi-ear-hearing-off',
  WIZARD: 'mdi-wizard-hat'
};

export const ALERT: Record<string, string> = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success'
};

export const CALLER_COUNT: Record<string, string> = {
  MAX_VALUE: '2'
};